import React from "react";
import FileDropzone from "./FileDropzone";
import SummaryRegisteredData from "../SummaryRegisteredData/SummaryRegisteredData";
import { MdInfoOutline, MdDownload } from "react-icons/md";
import { downloadTemplateCSV } from "../utils/fileUtils";

const FileUploadStep = ({
  file,
  onFileSelect,
  onSubmit,
  isLoading,
  beneficiaryData,
  beneficiarios,
}) => {
  return (
    <div className="w-full max-w-4xl bg-white rounded-lg shadow-sm p-6 mb-6">
      <div className="mb-4">
        <h2 className="text-xl font-medium text-gray-800">
          Selecione o arquivo de beneficiários
        </h2>
        <p className="text-gray-600 text-sm mt-1">
          Carregue um arquivo CSV contendo os dados dos beneficiários.
          <button
            onClick={downloadTemplateCSV}
            className="ml-2 text-emerald-600 hover:text-emerald-800 underline transition-colors"
          >
            Baixar modelo de arquivo
          </button>
        </p>
      </div>

      <form
        className="flex flex-col w-full justify-center items-center"
        onSubmit={onSubmit}
      >
        <FileDropzone
          file={file}
          onFileSelect={onFileSelect}
          isLoading={isLoading}
        />

        {beneficiaryData && beneficiaryData.header && (
          <div className="w-full bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4">
            <div className="flex items-start">
              <MdInfoOutline className="text-xl text-amber-600 mr-2 mt-0.5" />
              <div>
                <p className="text-amber-800 font-medium">
                  Dados já carregados
                </p>
                <p className="text-amber-700 text-sm">
                  Já existem dados de beneficiários no sistema. Ao importar um
                  novo arquivo, os dados atuais serão substituídos.
                </p>
              </div>
            </div>
          </div>
        )}

        <button
          className={`p-3 rounded-lg w-full max-w-xs font-medium transition-colors duration-200 
            ${
              file
                ? "bg-emerald-600 text-white hover:bg-emerald-700 focus:ring-2 focus:ring-emerald-400"
                : "bg-gray-200 text-gray-500 cursor-not-allowed"
            }`}
          type="submit"
          disabled={!file || isLoading}
        >
          {isLoading ? (
            <span className="flex items-center justify-center">
              <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white mr-2" />
              Processando...
            </span>
          ) : (
            "Enviar arquivo"
          )}
        </button>

        <button
          onClick={downloadTemplateCSV}
          className="mt-4 p-3 rounded-lg w-full max-w-xs font-medium bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors duration-200"
          type="button"
        >
          <MdDownload className="inline-block mr-2" />
          Baixar modelo de arquivo CSV
        </button>
      </form>

      {beneficiaryData && beneficiaryData.header && !beneficiarios && (
        <div className="mt-8 w-full">
          <h3 className="text-lg font-medium text-gray-700 mb-2">
            Dados atualmente registrados
          </h3>
          <div className="bg-gray-50 rounded-lg border border-gray-200 p-4">
            <SummaryRegisteredData
              beneficiaryData={beneficiaryData}
              selectedVariable="total"
              selectedCity={null}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUploadStep;
